<template>
  <round :device="device">
    <div>
      <img :src="icon" style="height: 65px;"/>
    </div>
    <div slot="footer" :class="device && device.advanced===1?'footer-radius':'footer-text'">
      <template v-if="device &&  device.advanced === 1">
        <div v-if="device.enableCCT === 1">
          <div>
            <span class="radius" cool @click="changeCCT('cool')" :selected="selected==='cool'"></span>
          </div>
          <div>
            <span>冷色</span>
          </div>
        </div>
        <div v-if="device.enableCCT === 1">
          <div>
            <span class="radius" warm @click="changeCCT('warm')" :selected="selected==='warm'"></span>
          </div>
          <div>
            <span>暖色</span>
          </div>
        </div>
        <div v-if="device.enableCCT === 1 || device.enableBR === 1">
          <div>
          <span class="radius" more @click="showMore">
            <span></span>
            <span></span>
            <span></span>
          </span>
          </div>
          <div>
            <span>更多</span>
          </div>
        </div>
      </template>
      <template v-else>
        <div v-text="text"></div>
      </template>
    </div>
  </round>
</template>
<script>
import Round from './Round'
import api from '../model/device'
import { Message } from 'element-ui'
import { mapState } from 'vuex'

export default {
  name: 'Light',
  data () {
    return {}
  },
  props: {
    device: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState(['zone']),
    selected () {
      if (this.device.cct >= 5500) {
        return 'cool'
      } else {
        return 'warm'
      }
    },
    icon () {
      if (this.device.state) {
        if (this.device.device_node_type === 37) {
          return require('../assets/images/device/light/classroomlight-k.png')
        } else if (this.device.device_node_type === 39) {
          return require('../assets/images/device/light/blackboardlight-k.png')
        } else {
          return require('../assets/images/device/light/device_light_e.png')
        }
      } else {
        if (this.device.device_node_type === 37) {
          return require('../assets/images/device/light/classroomlight.png')
        } else if (this.device.device_node_type === 39) {
          return require('../assets/images/device/light/blackboardlight.png')
        } else {
          return require('../assets/images/device/light/device_light.png')
        }
      }
    },
    text () {
      return this.device.state ? '已开启' : '已关闭'
    }
  },
  components: {
    Round
  },
  methods: {
    async changeCCT (type) {
      // 测试
      const cct = type === 'cool' ? 6500 : 2700
      try {
        await api.singleControl(this.device, 'cct', cct)
      } catch (e) {
        Message.error(e.message)
      }
    },
    showMore () {
      this.$router.push({ name: 'lightDetail', params: { id: this.device.id, device: this.device } })
    }
  }
}
</script>
<style scoped lang="less">
.round {
  .footer-text {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 400;
    height: 100%;
    color: rgba(89, 89, 89, 1);
  }
  .footer-radius {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    text-align: center;
    font-size: 12px;
    font-weight: 400;
    color: rgba(89, 89, 89, 1);
    .radius {
      display: inline-block;
      width: 45px;
      height: 45px;
      cursor: pointer;
      border-radius: 50%;
    }

    .radius[warm] {
      background: linear-gradient(180deg, rgba(255, 218, 120, 1), rgba(255, 246, 210, 1));
    }

    .radius[cool] {
      background: linear-gradient(180deg, rgba(238, 247, 252, 1), rgba(253, 251, 251, 1));
    }

    .radius[more] {
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 5px 16px 2px rgba(85, 85, 85, 0.08);
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 4px;
    }

    .radius[more] > span {
      display: inline-block;
      background: rgba(85, 85, 85, 1);
      border-radius: 50%;
      height: 4px;
      width: 4px;
      margin-right: 4px;
    }

    .radius[more] > span:last-child {
      margin-right: 0;
    }

    .radius[selected] {
      width: 41px;
      height: 41px;
      border: 2px solid #e5e5e5;
    }
  }
}
</style>
